import { Card } from '@ipfabric/ui-components/Card/Card';
import { Link } from '@ipfabric/ui-components/Link/Link';
import { DEFAULT_APP_SETTING } from '@ipfabric/utils';
import type { CommandResponseFieldValues } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/commandResponse';
import type { DeviceAuthenticationFieldValues } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/deviceAuthentication';
import type { LoginTimeoutFieldValues } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/loginTimeout';
import type { SessionTimeoutFieldValues } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/sessionTimeout';
import type { ReactNode } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { SearchableSection } from '../DiscoverySearch/SearchableSection';

type Props = {
  form: UseFormReturn<
    LoginTimeoutFieldValues &
      SessionTimeoutFieldValues &
      CommandResponseFieldValues &
      DeviceAuthenticationFieldValues
  >;
  renderSnippet: (
    name:
      | 'loginTimeout'
      | 'sessionTimeout'
      | 'deviceAuthentication'
      | 'commandResponse',
  ) => ReactNode;
};

export const TimeoutSettings = (props: Props) => (
  <Card>
    <SearchableSection
      id='advanced-cli-timeout-settings-card'
      highlightOn={['advancedCli']}
      className='p flex flex-col'
    >
      <div className='flex flex-row gap-xs'>
        <div className='text-default text-level-5 font-semibold font-heading'>
          Timeout settings
        </div>
        <Link
          renderAs='button'
          onClick={() => {
            props.form.setValue(
              'sessionTimeout',
              DEFAULT_APP_SETTING.timeouts.cmdTimeout.toString(),
              { shouldDirty: true, shouldTouch: true },
            );
            props.form.setValue(
              'commandResponse',
              DEFAULT_APP_SETTING.timeouts.commandResponseTimeoutMinutes.toString(),
              { shouldDirty: true, shouldTouch: true },
            );
            props.form.setValue(
              'loginTimeout',
              DEFAULT_APP_SETTING.timeouts.readyTimeout.toString(),
              { shouldDirty: true, shouldTouch: true },
            );
            props.form.setValue(
              'deviceAuthentication',
              DEFAULT_APP_SETTING.timeouts.unauthenticatedTimeout.toString(),
              { shouldDirty: true, shouldTouch: true },
            );
          }}
        >
          Reset to default values
        </Link>
      </div>
      <SearchableSection id='advanced-cli-login-timeout'>
        <div className='my-xs'>{props.renderSnippet('loginTimeout')}</div>
      </SearchableSection>
      <SearchableSection id='advanced-cli-session-timeout'>
        <div className='my-xs'>{props.renderSnippet('sessionTimeout')}</div>
      </SearchableSection>
      <SearchableSection id='advanced-cli-device-authentication'>
        <div className='my-xs'>
          {props.renderSnippet('deviceAuthentication')}
        </div>
      </SearchableSection>
      <SearchableSection id='advanced-cli-command-response'>
        <div className='my-xs'>{props.renderSnippet('commandResponse')}</div>
      </SearchableSection>
    </SearchableSection>
  </Card>
);
